import React, { useEffect, useState } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import { connect } from 'react-redux'

import loadable from 'components/utils/lazyImport'
import { selectLoggedIn } from 'selectors/accountSelectors'

import { getUpcomingOrders } from 'selectors/orderSelectors'
import { isSupportAssistantEnabled } from 'selectors/featuresSelectors'

const SupportAssistantChatWidget = loadable(() => import(/* webpackChunkName: 'SupportAssistantChatWidget' */ 'supportAssistant/components/ChatWidget/ChatWidget'), <div />)

const supportAssistantChatWidgetRoute = [
  '/:regionCode/',
  '/:regionCode/account',
  '/:regionCode/account/my-escapes',
]

interface Props extends RouteComponentProps<any> {
  isLoggedIn: boolean;
  orders: Array<App.Order>
  isSupportAssistantEnabled: boolean
}

function SupportAssistantChatWidgetRoutes(props: Props) {
  const { isLoggedIn, orders, isSupportAssistantEnabled } = props
  const [showChatWidget, setShowChatWidget] = useState<boolean>(false)

  useEffect(() => {
    if (showChatWidget || !isLoggedIn || !isSupportAssistantEnabled) {
      return
    }

    const hotelOrBedbankOrders = orders.filter((order) => order.items.length > 0 || order.bedbankItems.length > 0)
    setShowChatWidget(hotelOrBedbankOrders.length > 0)
  }, [isLoggedIn, orders, showChatWidget, isSupportAssistantEnabled])

  if (!showChatWidget || !isSupportAssistantEnabled) {
    return null
  }

  return <Route exact path={supportAssistantChatWidgetRoute} component={SupportAssistantChatWidget} />
}

function mapStateToProps(state: App.State) {
  return {
    isLoggedIn: selectLoggedIn(state),
    orders: getUpcomingOrders(state),
    isSupportAssistantEnabled: isSupportAssistantEnabled(state),
  }
}

export default connect(mapStateToProps)(SupportAssistantChatWidgetRoutes)
